import "../css/Terminos.css";
import { useNavigate } from "react-router-dom";


const Terminos = () => {
  const navigate = useNavigate();

  return (
    <div className="terminos-container">
      <div className="terminos-box">
        <h1>Términos y Condiciones</h1>
        <p className="fecha">Última actualización: Marzo 2026</p>

       

        <section>
          <h2>1. Naturaleza del Servicio</h2>
          <p>
            Esta plataforma es un juego gratuito de predicciones deportivas
            relacionado con el Mundial 2026. No constituye un sistema de
            apuestas con dinero real ni promueve el juego de azar.
          </p>
        </section>

        <section>
          <h2>2. Registro de Usuario</h2>
          <p>
            Para participar es necesario crear una cuenta proporcionando
            información veraz. Cada usuario es responsable de mantener la
            confidencialidad de su contraseña.
          </p>
        </section>

        <section>
          <h2>3. Sistema de Puntuación</h2>
          <p>
            Los puntos se asignan en base a aciertos en resultados y predicciones.
            La plataforma puede modificar el sistema de puntuación cuando sea
            necesario para mejorar la experiencia del juego.
          </p>
        </section>
        <section>
        <h2>4. Naturaleza de los Puntos</h2>
        <p>
            Los puntos obtenidos dentro de la plataforma no tienen valor monetario,
            no son transferibles y no pueden ser canjeados por dinero ni por bienes
            o servicios. Son únicamente parte del sistema interno de juego.
        </p>
        </section>

        <section>
          <h2>5. Conducta del Usuario</h2>
          <p>
            Está prohibido el uso de bots, múltiples cuentas, manipulación del
            sistema o cualquier intento de alterar el funcionamiento normal del
            juego.
          </p>
        </section>

        <section>
          <h2>6. Suspensión de Cuenta</h2>
          <p>
            Nos reservamos el derecho de suspender o eliminar cuentas que
            incumplan estos términos sin previo aviso.
          </p>
        </section>

        <section>
          <h2>7. Protección de Datos</h2>
          <p>
            La información proporcionada se utiliza únicamente para el
            funcionamiento de la plataforma y no se comparte con terceros.
          </p>
        </section>

        <section>
          <h2>8. Modificaciones</h2>
          <p>
            Estos términos pueden actualizarse en cualquier momento. El uso
            continuado de la plataforma implica la aceptación de dichos cambios.
          </p>
        </section>

         <section>
        <h2>Jurisdicción</h2>
        <p>
            Estos términos se rigen por las leyes de la República Argentina.
            Cualquier disputa será resuelta en los tribunales correspondientes
            a dicha jurisdicción.
        </p>
        </section>

        
        <div className="terminos-footer">
          <button onClick={() => navigate("/register")}>
            Volver al Registro
          </button>
        </div>

      </div>
    </div>
  );
};

export default Terminos;